import type { CSS } from '@grupoboticario/flora-react'

export const pageWrapperCss: CSS = {
  paddingBottom: '$6'
}

export const sectionSpacerCss: CSS = {
  marginBottom: '$6'
}

export const fullWidthButtonCss: CSS = {
  width: '100%',
  '@desktop': { width: 'auto' }
}
